import React, { useState } from 'react';

const CircleImage = ({ src, alt = 'Profile', size = 100 }) => {
  const [isSpinning, setIsSpinning] = useState(false);

  const handleMouseEnter = () => {
    setIsSpinning(true);
    setTimeout(() => setIsSpinning(false), 300);
  };

  return (
    <div
      style={{
        display: 'inline-block',
        perspective: '1000px',
      }}
    >
      <img
        src={src || '/placeholder-profile.png'} // optional fallback
        alt={alt}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          objectFit: 'cover',
          borderRadius: '50%',
          transition: 'transform 0.6s ease',
          transform: isSpinning ? 'rotateY(360deg)' : 'rotateY(0deg)',
          boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        }}
        onMouseEnter={handleMouseEnter}
        onTouchStart={handleMouseEnter}
      />
    </div>
  );
};

export default CircleImage;